var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"删除钻探任务","visible":_vm.dialogVisible,"width":"410px","center":true,"top":"30vh","close-on-click-modal":false,"destroy-on-close":true,"before-close":_vm.cancelCreate}},[_c('p',[_vm._v("当前仅支持删除【未开始】的钻探任务")]),_c('button',{on:{"click":_vm.cancelCreate}},[_vm._v("我知道")])])
}
var staticRenderFns = []

export { render, staticRenderFns }